module.exports = __webpack_public_path__ + "static/media/SA.d0578a97.webp";